export default "__VITE_ASSET__swug8pFH__"